function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { string } from 'prop-types';
import { Field } from 'react-final-form';
import { Icon, Popover, RadioField } from '@unite-us/app-components';
import { SHARE_METHODS } from '../../constants';
import './ShareMethodField.scss';

// eslint-disable-next-line max-len
var SMS_POPOVER = 'This text message contains a web link to the resource page. Please only use this option if the person you\'re texting has a smart phone.';
var PhoneLabel = /*#__PURE__*/React.createElement("span", {
  className: "sms-cont"
}, "Text", /*#__PURE__*/React.createElement(Popover, {
  id: "sms-tooltip",
  onClick: function onClick(e) {
    e.stopPropagation();
    e.preventDefault();
  },
  className: "w-56 p-2 ",
  position: "right",
  content: /*#__PURE__*/React.createElement("span", {
    className: "text-xs",
    "aria-hidden": true
  }, SMS_POPOVER),
  showArrow: true
}, /*#__PURE__*/React.createElement(Icon, {
  icon: "InfoCircle",
  color: "action-blue",
  canReceiveFocus: false,
  className: "ml-1 tooltipIcon"
})));
var shareMethods = [{
  label: PhoneLabel,
  value: SHARE_METHODS.PHONE
}, {
  label: 'Email',
  value: SHARE_METHODS.EMAIL
}, {
  label: 'Print',
  value: SHARE_METHODS.PRINT
}];
export default function ShareMethodField(_ref) {
  var shareMethod = _ref.shareMethod,
    uniqueId = _ref.uniqueId;
  return /*#__PURE__*/React.createElement(Field, {
    name: "shareMethod",
    value: shareMethod,
    initialValue: shareMethod,
    required: true,
    type: "radio",
    className: "shareMethodField",
    id: "share-message-type-".concat(uniqueId)
  }, function (params) {
    return /*#__PURE__*/React.createElement(RadioField, _extends({
      id: "share-message-type",
      inline: true,
      inlineLabel: true,
      label: "Share Method",
      labelClassName: "ui-form-field__label mb-3",
      className: "radioField",
      options: shareMethods,
      style: {
        input: 'radioField'
      }
    }, params));
  });
}
ShareMethodField.propTypes = {
  shareMethod: string.isRequired,
  uniqueId: string.isRequired
};
//# sourceMappingURL=ShareMethodField.js.map